<template>
	<div class="cenNav">
		<div class="cenNavBox">
			<div class="cenNavBoxFor" v-for="(item,index) in list" :key="index" @click="goScroll(item,index)" :class="current==index?'xz':'wxz'">
				{{item.name}}
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props:{
			list:{
				typeof:Array,
				default:[]
			},
		},
		data() {
			return {
				current:0
			}
		},
		methods: {
			goScroll(e,a){
				// document.documentElement.scrollTop = 0
				this.current=a;
				if(e.value=='qb'){
					var element;
					if(this.nowVibe=='pc'){
						element= document.documentElement
					}else{
						element = document.documentElement.scrollTop ? document.documentElement : document.body;
					}
					// var element = document.documentElement.scrollTop ? document.documentElement : document.body;
						element.scrollTop = 0;
					// document.documentElement.scrollTop = 0;
					
					return
				}
				this.$emit('goScroll',e.value)
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
.cenNav{
	position: sticky;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 999;
	height: 56px;
	background-color: #fff;
	border-bottom: 1px solid #E5E5E5;
	display: flex;
	align-items: center;
	.cenNavBox{
		width: 1200px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		overflow-x: auto;
		.cenNavBoxFor{
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 500;
			color: #000000;
			margin-right: 60px;
			cursor: pointer;
		}
		.xz{
			font-weight: bold;
		}
		.wxz{
			font-weight: 300;
		}
	}
}
@media screen and (max-width:1200px) {
	.cenNavBox{
		width: 100% !important;
		padding: 0 30px !important;
		.cenNavBoxFor{
			font-size: 16px !important;
			margin-right: 10px !important;
		}
	}
}
</style>